type FormValue = string | number | boolean | null | undefined

type SubmitHiddenFormOptions = {
  action: string
  method?: 'post' | 'patch' | 'delete'
  values?: Record<string, FormValue>
}

export function submitHiddenForm({ action, method = 'post', values = {} }: SubmitHiddenFormOptions) {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = action

  if (method !== 'post') {
    const methodInput = document.createElement('input')
    methodInput.type = 'hidden'
    methodInput.name = '_method'
    methodInput.value = method
    form.appendChild(methodInput)
  }

  Object.entries(values).forEach(([name, value]) => {
    if (value === null || value === undefined || value === '') return

    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = typeof value === 'boolean' ? String(value) : String(value)
    form.appendChild(input)
  })

  document.body.appendChild(form)
  form.submit()
}
